import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { deleteAgency } from '@/modules/Agency/gql/agency.gql'
import { SnackType } from '@/interfaces/snack'
import { Agency } from '@/modules/Agency/interfaces/agency'
import AgencyForm from '@/modules/Agency/components/AgencyForm.vue'
import { showErrors, showNotification } from '@/utils/snack'

@Component({
  components: {
    AppDialog,
    AgencyForm,
    AppTextSearch
  }
})
export default class AgencyDialog extends Vue {
  targetAgency: Agency | null = null

  agencyDialog = {
    show: false,
    title: 'New General Agent',
    disable: false,
    actionType: 'new',
    highlightTitle: ''
  }

  deleteAgencyDialog = {
    show: false,
    title: 'Delete General Agent',
    disable: false
  }

  showAgencyDialog (e: Event, targetAgency?: Agency) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New General Agent : '
    let highlightTitle = ''
    if (targetAgency) {
      this.targetAgency = targetAgency
      actionType = 'edit'
      title = 'Edit General Agent : '
    }
    this.agencyDialog = {
      actionType,
      show: true,
      title,
      disable: false,
      highlightTitle
    }
  }

  hideAgencyDialog () {
    this.targetAgency = null
    this.agencyDialog = {
      actionType: 'new',
      show: false,
      title: 'New General Agent',
      disable: false,
      highlightTitle: ''
    }
  }

  async deleteAgency (e: Event, targetAgency: Agency) {
    e.preventDefault()
    e.stopPropagation()
    this.targetAgency = targetAgency
    this.deleteAgencyDialog.show = true
  }

  async deleteAgencyPost () {
    if (!this.targetAgency) {
      return
    }
    const { id } = this.targetAgency
    this.deleteAgencyDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteAgency,
        variables: {
          agencyId: Number(id)
        }
      })

      const res = result.data.deleteAgency
      if (res) {
        showNotification({
          msg: 'Delete general agent successfully',
          type: SnackType.Success
        })
        this.targetAgency = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
